module.exports = "./img/f70059404fa69675620ffc5e9b409b9b.jpg";